
import { defineComponent, PropType } from 'vue'
import { filterDefault } from '@/helpers/commons/filterHelper'
import { formatDate } from '@/helpers/commons/localeHelper'
import { iKpi, iKpiListItem } from '../KpiDocumentDesigner'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import kpiDocumentDesignerKpiListCardDescriptor from './KpiDocumentDesignerKpiListCardDescriptor.json'

export default defineComponent({
    name: 'kpi-edit-kpi-select-dialog',
    components: { Column, DataTable, Dialog },
    props: { visible: { type: Boolean }, kpiList: { type: Array as PropType<iKpi[]> }, data: { type: Object as PropType<{ kpi: iKpiListItem[] }>, required: true } },
    emits: ['close', 'kpiSelected'],
    data() {
        return {
            kpiDocumentDesignerKpiListCardDescriptor,
            filters: { global: [filterDefault] } as Object,
            selectedKpiAssociations: [] as iKpi[]
        }
    },
    watch: {
        visible() {
            this.setSelectedKpiAssociations()
        }
    },
    async created() {
        this.setSelectedKpiAssociations()
    },
    methods: {
        getFormattedDate(date: any) {
            return formatDate(date)
        },
        setSelectedKpiAssociations() {
            this.selectedKpiAssociations = []

            if (this.data.kpi) {
                this.kpiList?.forEach((kpi: iKpi) => {
                    const index = this.data.kpi.findIndex((kpiListItem: iKpiListItem) => kpi.name === kpiListItem.name)
                    if (index !== -1) this.selectedKpiAssociations.push(kpi)
                })
            }
        },
        closeKpiAssociations() {
            this.selectedKpiAssociations = []
            this.$emit('close')
        },
        addKpiAssociations() {
            this.$emit('kpiSelected', this.selectedKpiAssociations)
        }
    }
})
